<template>
    <div class="animated fadeIn">
        <loading :active.sync="disabledField"></loading>
        <notifications group="foo" />
        <b-row class="text-right">
            <b-col cols="6" sm="4" md="2" class="mb-3">
                <b-button size="sm" block v-bind:variant="btnConnectClass()" v-on:click="changeWidgetStatus()" :disabled="btnChangeDisabled()">{{btnConnectText()}}</b-button>
            </b-col>
        </b-row>
        <b-row>
            <b-col md="6">
                <b-card>
                    <div slot="header">
                        <b-row >
                            <b-col cols="6" sm="6" md="6">
                                <i class="fa fa-edit"></i><strong> Дополнительные поля</strong> 
                            </b-col>
                            <b-col cols="6" sm="6" md="6" class="text-right">
                                <b-button type="submit" right size="sm" variant="" v-on:click="addField()"><i class="fa fa-plus"></i> Добавить поле</b-button>
                            </b-col>
                        </b-row>
                    </div>

                    <div>
                        <b-row class="mb-3" v-for="item in settings">
                            <b-col md="6"><b-form-select :options="amoLeadFields" v-model="item.field"></b-form-select></b-col>
                            <b-col md="2">
                                <b-input type="text" placeholder="Единица измерения" v-model="item.unit" v-bind:value="item.unit" />
                            </b-col>
                            <b-col md="2">
                                <input type="checkbox" id="checkbox" v-model="item.avg"> ср. %
                            </b-col>
                            <b-col md="2">
                                <b-button right size="sm" variant="danger" v-on:click="removeField()"><i class="fa fa-minus"></i></b-button>
                            </b-col>
                        </b-row>
                    </div>

                    <div slot="footer">
                        <b-button type="submit" :disabled="!widget.isActive" size="sm" variant="primary" v-on:click="saveSettings()"><i class="fa fa-save"></i> Сохранить</b-button>
                    </div>
                </b-card>
            </b-col>

            <b-col md="6">
                <b-card header-tag="header" footer-tag="footer">
                    <div slot="header"> <i class="icon-notebook icons"></i><strong> Описание</strong></div>
                    <p>Для оперативного анализа большого потока сделок иногда не достаточно суммы по Бюджету на каждом этапе. Данный виджет позволяет выводить в "шапку" под заголовками этапов дополнительные суммы по выбранным числовым полям в сделке.</p>
                </b-card>
            </b-col>
        </b-row>
  </div>
</template>

<script>
    import WidgetsService from '@/services/WidgetsService'
    import widgetEvents from '@/views/widgets/Widget';
    import VueTribute from 'vue-tribute'

    export default {
        mixins: [
            widgetEvents
        ],
        components: { VueTribute }, 
        name: 'ExtendSumHeader',
        data () {
            return {
                widget: { isActive : false },
                widgetId: '5d1336c72805ec2fe32c0a7d',
                amoLeadFields : [],
                settings: [],
                disabledField: false,
                onLoad: false,
            }
        },
        computed: {

        },
        created: function () {
            this.getWidget(() => {
                this.getLeadFields();
            });
        },
        methods: {
            async getLeadFields () {
                this.disabledField = true;                
                await WidgetsService.getLeadFields([2]).then(response => {                    
                    this.amoLeadFields = response.data.result;
                    this.disabledField = false;

                }).catch(err => { return console.log(err); });
            },
            addField : function (){
                this.settings.push({ field: '0', unit: 'ед.' });
            },
            removeField(item) {
                this.settings.splice(this.settings.indexOf(item), 1);
                this.saveSettings();
            },
        },
    };
    
</script>